import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const SocialMediaContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="web-visitor-content">
      <div className="datenschutz-container">
        <section className="datenschutz-section">
          <h2>{t('socialMediaPrivacyTitle')}</h2>
          <h3>{t('socialMediaPrivacyDate')}</h3>
          <p>{t('socialMediaIntro')}</p>
        </section>
        <section className="datenschutz-section">
          <h2>1. {t('socialMediaResponsible')}</h2>
          <div className="datenschutz-content">
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('socialMediaResponsibleText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>2. {t('socialMediaDataProcessing')}</h2>
          <div className="datenschutz-content">
            <p>{t('socialMediaDataProcessingText')}</p>
            <h3>2.1 {t('socialMediaPurposes')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('socialMediaPurposesText')) }}></p>
            <h3>2.2 {t('socialMediaInsights')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('socialMediaInsightsText')) }}></p>
          </div>
        </section>
        
        <section className="datenschutz-section">
          <h2>3. {t('socialMediaRecipients')}</h2>
          <div className="datenschutz-content">
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('socialMediaRecipientsText')) }}></p>
          </div>
        </section>
        
        <section className="datenschutz-section">
          <h2>4. {t('socialMediaYourRights')}</h2>
          <div className="datenschutz-content">
            <p>{t('socialMediaYourRightsText')}</p>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('socialMediaRightsList')) }}></div>
          </div>
        </section>
        
        <section className="datenschutz-section">
          <h2>5. {t('socialMediaUpdates')}</h2>
          <div className="datenschutz-content">
            <p>{t('socialMediaUpdatesText')}</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SocialMediaContent;
